import { useStaticQuery, graphql } from 'gatsby'

export const useInplayPostdata = () => {
  const { allPostsJson } = useStaticQuery(
    graphql`
      query InplayPostDataQuery {
        allPostsJson(filter: { status: { eq: "inplay" } }) {
          edges {
            node {
              id
              slug
              sport
              competition
              date
              epoch
              start
              status
              marketCount
              team1title
              team2title
              gametime
              gameperiod
              gamescore
              markets {
                title
                outcomes {
                  name
                  odds
                }
              }
            }
          }
        }
      }
    `
  )
  return allPostsJson.edges
}
